import { IFxSettingsDTO } from '@modeso/types__aumico-lib-companies-be';
import { DataCenterZone } from '@modeso/types__aumico-lib-core-be';
import { CPMMState } from '../enums/cpmm-state.enum';
import { OrganizationState } from '../enums/organization-state.enum';
import { LicenceDataDto } from './getPackageDto.type';

export class AdminCompanyDto {
    public _id!: string;
    public name!: string;
    public label!: string | null;
    public active!: boolean;
}

/** One company of the functional-currency billing view (REV-21512). `fx` is the stored
 *  entitlement; the billable periods are derived from it with the shared `fxBillingPeriods`. */
export class FxBillingCompanyDto {
    public _id!: string;
    public name!: string;
    public organizationId!: string;
    public organizationName!: string | null;
    public dataCenter!: DataCenterZone;
    public fx?: IFxSettingsDTO;
}

export enum UserStateDto {
    ACTIVE = 'active',
    PENDING = 'pending',
    SUSPENDED = 'suspended',
    DELETED = 'deleted',
}

export enum TierDto {
    LIGHT = 'light',
    STANDARD = 'standard',
    PRO = 'pro',
}

export class UserInfoDto {
    public email!: string;
    public internalId!: string;
}

export class OrganizationSearchUserDto {
    public internalId!: string;
    public firstName!: string;
    public lastName!: string;
    public email!: string;
    public organizationRole!: string;
    public appRole!: string;
    public locale!: string;
    public userState!: UserStateDto;
}

export class OrganizationSearchResultDto {
    public name!: string;
    public organizationId!: string;
    public zip?: string | null;
    public city?: string | null;
    public countryISO31661Alpha2Code!: string;
    public locale!: string;
    public state!: OrganizationState;
    public tier!: TierDto;
    public activationState!: CPMMState;
    public abcpPreview?: boolean;
    public dataCenter!: DataCenterZone;
    public users!: OrganizationSearchUserDto[];
    public lastChanged!: Date;
    public lastChangedBy!: UserInfoDto;
    public usage!: string;
    public packageSize!: number;
    public mandateWorkflows!: number;
    public closingWorkflows!: number;
    public expirationDate!: Date;
    public licenceData: LicenceDataDto[] = [];
    public companies: AdminCompanyDto[] = [];
}

export interface OrganizationSearchFilterDto {
    userSearch?: string;
    orgSearch?: string;
    organizationRoles?: string[];
    appRoles?: string[];
    countries?: string[];
    states?: OrganizationState[];
    tiers?: TierDto[];
    expirationDate?: Date | null;
}
